import React from "react";
import { type FreefieldInputProps } from "shared/utils/freeFields/models";
import { TextArea } from "semantic-ui-react";

const FreefieldTextMultiLine = (props: FreefieldInputProps) => {
  const [text, setText] = React.useState(props.initialValue ?? "");

  return <TextArea
    value={text}
    onChange={(_, { value }) => { setText(value.toString()); }}
    onBlur={() => { props.onChange(text); }}
    maxLength={serverReference.constants.freeField.maxMultiLineTextLength}
    style={{ fieldSizing: "content", minHeight: 100 }}
    rows={5}
  />;
};

export default FreefieldTextMultiLine;